import React from 'react';
import {useUnreadNotificationsCount} from '@rocket-ui/lk-api';
import {cn} from '@rocket-ui/tools';

export function formatUnreadCount(count: number): string {
	if (count > 99) return '99+';

	return String(count);
}

export function useUnreadNotificationsLabel(): string {
	const {data} = useUnreadNotificationsCount();
	const unreadCount = data?.unreadCount ?? 0;

	if (unreadCount > 0) return `Уведомления, непрочитано ${unreadCount}`;

	return 'Уведомления';
}

export function UnreadNotificationsBadge({className}: {className?: string}): React.ReactElement | null {
	const {data} = useUnreadNotificationsCount();
	const unreadCount = data?.unreadCount ?? 0;

	if (unreadCount <= 0) return null;

	return (
		<span
			className={cn(
				'absolute -right-2.5 -top-2 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-[#FFF174] px-1 text-[10px] font-semibold leading-none text-black',
				className,
			)}
		>
			{formatUnreadCount(unreadCount)}
		</span>
	);
}
